(function () {
  const instances = new WeakMap();

  function getRoot(node) {
    if (!node) return null;
    if (node.matches && node.matches('[data-jatajoot-testimonial]')) return node;
    return node.querySelector ? node.querySelector('[data-jatajoot-testimonial]') : null;
  }

  function readNumber(styles, name, fallback) {
    const raw = (styles.getPropertyValue(name) || '').trim();
    const value = parseFloat(raw);
    if (!Number.isFinite(value)) return fallback;
    if (raw.indexOf('rem') !== -1) {
      const rem = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      return value * (Number.isFinite(rem) && rem > 0 ? rem : 10);
    }
    return value;
  }

  function circularDelta(index, active, total) {
    let delta = index - active;
    if (delta > total / 2) delta -= total;
    if (delta < -(total / 2)) delta += total;
    return delta;
  }

  function initRoot(root) {
    if (!root || instances.has(root)) return;

    const avatars = Array.from(root.querySelectorAll('[data-jt-avatars] [data-jt-index]'));
    const quoteWrap = root.querySelector('[data-jt-quotes]');
    const quotes = Array.from(root.querySelectorAll('[data-jt-quotes] [data-jt-index]'));
    const radios = Array.from(root.querySelectorAll('.jatajoot-testimonial__pagination input[type="radio"]'));
    const total = avatars.length;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const enableAutoplay = root.getAttribute('data-jt-autoplay') === 'true' && !reduceMotion && total > 1;
    const interval = parseInt(root.getAttribute('data-jt-interval'), 10) || 4000;
    const cleanups = [];
    let active = 0;
    let timer = null;

    function metrics() {
      const styles = window.getComputedStyle(root);
      return {
        step: readNumber(styles, '--jt-step', 144),
        size0: readNumber(styles, '--jt-size-0', 140),
        size1: readNumber(styles, '--jt-size-1', 92),
        size2: readNumber(styles, '--jt-size-2', 72),
      };
    }

    function syncQuoteHeight() {
      const activeQuote = quotes[active];
      if (!quoteWrap || !activeQuote) return;
      quoteWrap.style.minHeight = activeQuote.offsetHeight + 'px';
    }

    function positionAvatars() {
      const sizes = metrics();
      avatars.forEach(function (avatar, index) {
        const delta = circularDelta(index, active, total);
        const distance = Math.abs(delta);
        let size = sizes.size2;
        let opacity = 0.3;

        if (distance === 0) {
          size = sizes.size0;
          opacity = 1;
        } else if (distance === 1) {
          size = sizes.size1;
          opacity = 0.6;
        } else if (distance > 2) {
          avatar.style.width = '0px';
          avatar.style.height = '0px';
          avatar.style.opacity = '0';
          avatar.style.pointerEvents = 'none';
          avatar.style.zIndex = '0';
          avatar.style.transform = 'translate(-50%, -50%) translateX(' + delta * sizes.step + 'px)';
          return;
        }

        avatar.style.width = size + 'px';
        avatar.style.height = size + 'px';
        avatar.style.opacity = String(opacity);
        avatar.style.pointerEvents = 'auto';
        avatar.style.zIndex = String(10 - distance);
        avatar.style.transform = 'translate(-50%, -50%) translateX(' + delta * sizes.step + 'px)';
      });
    }

    function setActive(nextIndex, fromUser) {
      if (total < 1) return;
      const next = ((nextIndex % total) + total) % total;
      if (next === active && root.classList.contains('is-ready')) {
        if (fromUser) restartTimer();
        return;
      }

      active = next;
      root.classList.add('is-ready');

      avatars.forEach(function (avatar, index) {
        const isActive = index === active;
        avatar.classList.toggle('is-active', isActive);
        avatar.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      quotes.forEach(function (quote, index) {
        quote.classList.toggle('is-active', index === active);
      });

      radios.forEach(function (radio, index) {
        radio.checked = index === active;
      });

      positionAvatars();
      syncQuoteHeight();
      if (fromUser) restartTimer();
    }

    function nextSlide() {
      setActive(active + 1, false);
    }

    function stopTimer() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startTimer() {
      if (!enableAutoplay || timer) return;
      timer = window.setInterval(nextSlide, interval);
    }

    function restartTimer() {
      stopTimer();
      startTimer();
    }

    avatars.forEach(function (avatar) {
      const onClick = function () {
        setActive(parseInt(avatar.getAttribute('data-jt-index'), 10), true);
      };
      avatar.addEventListener('click', onClick);
      cleanups.push(function () {
        avatar.removeEventListener('click', onClick);
      });
    });

    radios.forEach(function (radio) {
      const onChange = function () {
        if (!radio.checked) return;
        setActive(parseInt(radio.getAttribute('data-jt-index'), 10), true);
      };
      radio.addEventListener('change', onChange);
      cleanups.push(function () {
        radio.removeEventListener('change', onChange);
      });
    });

    const onEnter = function () {
      stopTimer();
    };
    const onLeave = function () {
      startTimer();
    };
    root.addEventListener('mouseenter', onEnter);
    root.addEventListener('mouseleave', onLeave);
    root.addEventListener('focusin', onEnter);
    root.addEventListener('focusout', onLeave);
    cleanups.push(function () {
      root.removeEventListener('mouseenter', onEnter);
      root.removeEventListener('mouseleave', onLeave);
      root.removeEventListener('focusin', onEnter);
      root.removeEventListener('focusout', onLeave);
    });

    let resizeTimer = null;
    const onResize = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        positionAvatars();
        syncQuoteHeight();
      }, 120);
    };
    window.addEventListener('resize', onResize);
    cleanups.push(function () {
      window.removeEventListener('resize', onResize);
      window.clearTimeout(resizeTimer);
    });

    setActive(0, false);
    startTimer();

    instances.set(root, {
      setActive: setActive,
      destroy: function () {
        stopTimer();
        cleanups.forEach(function (cleanup) {
          cleanup();
        });
        root.classList.remove('is-ready');
      },
    });
  }

  function destroyRoot(root) {
    const instance = root && instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  }

  function initAll(scope) {
    const context = scope || document;
    if (!context.querySelectorAll) return;
    context.querySelectorAll('[data-jatajoot-testimonial]').forEach(initRoot);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = getRoot(event.target);
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = getRoot(event.target);
    if (root) destroyRoot(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest ? event.target.closest('[data-jatajoot-testimonial]') : null;
    const instance = root && instances.get(root);
    if (!instance) return;
    const index = parseInt(event.target.getAttribute('data-jt-index'), 10);
    if (Number.isFinite(index)) instance.setActive(index, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
